import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './menuIcon.css'
import PropTypes from 'prop-types';

class TagNamePopUpModal extends Component{
    constructor(props){
        super(props)
        console.log(props)

        this.handleChangetag = this.handleChangetag.bind(this)
        this.handleChangeremark = this.handleChangeremark.bind(this)
    }

    handleChangetag(e){
        this.props.tagnamechange(e.target.value)
    }

    handleChangeremark(e){
        this.props.remarkschange(e.target.value)
    }

    render(){
        return(
            <div data-test = 'tagNamePopupModalComponent'>
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={this.props.closeTagModal}
                        style={{ color:"#524fa1" }}
                    >
                        Tag Name
                    </ModalHeader>
                    <ModalBody>
                    <div className="card">
                      <div className="card-body">
                        <form>
                            <div className="form-group">
                                Version(Tag Name) : <input className="form-control" type="text" onChange={this.handleChangetag}></input><br/>
                            </div>
                            <div className="form-group">
                                Remark : <textarea className="form-control" onChange={this.handleChangeremark}></textarea>
                            </div>
                        </form>
                      </div>
                    </div>

                    </ModalBody>
                    <ModalFooter>
                      <Button color="" className="btn btn-primary" onClick={this.props.sendToBenchAPI}>Ok</Button>
                    </ModalFooter>
                  </Modal>

            </div>

        )
    }
}
TagNamePopUpModal.propTypes={
tagnamechange:PropTypes.string,
remarkschange:PropTypes.string,
closeTagModal:PropTypes.string,
sendToBenchAPI:PropTypes.bool,
}
TagNamePopUpModal.defaultProps= {
sendToBenchAPI:true,
tagnamechange:[],
remarkschange:[],
closeTagModal:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default TagNamePopUpModal;
